import React, {useState} from 'react';
import {Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import TableHeader from "../layout/table/TableHeader";
import NoDataLabel from "../layout/NoDataLabel";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ModalDelete from "../layout/ModalDelete";
import {useNavigate} from "react-router-dom";
import Constants from "../../../utils/constants";
import {agenceALesCoordonnees} from "./agenceRules.js";

function AgencesTable({agences, onDelete}) {
    const navigate = useNavigate();
    const [label, setLabel] = useState("");
    const [objectToDelete, setObjectToDelete] = useState(null);
    const [open, setOpen] = useState(false);
    const [currentAgence, setCurrentAgence] = useState(null);

    const headCells = [
        {id: 'libelle', label: 'Libellé'},
        {id: 'codeCouleur', label: 'Couleur'},
        {id: 'coordonnees', label: 'Coordonnées'},
    ];

    const openDeleteConfirmModal = (a) => {
        setCurrentAgence(a);
        setLabel("Êtes-vous sûr de vouloir supprimer l'agence : ");
        setObjectToDelete(a.libelle);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentAgence(null);
    };

    const handleEditClick = (id) => {
        navigate(Constants.APP_ROUTE_ADMIN_AGENCES_EDIT.replace(':id', id));
    };

    const handleDelete = () => {
        onDelete(currentAgence);
        handleClose();
    };

    return (
        <React.Fragment>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="agences table" size="small">
                    <TableHeader headCells={headCells}/>
                    <TableBody>
                        {agences && agences.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={4} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucune agence enregistrée"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {agences && agences.map((agence) => (
                            <React.Fragment key={agence.id}>
                                <TableRow hover onClick={() => handleEditClick(agence.id)} style={{cursor: 'pointer'}}>
                                    <TableCell>{agence.libelle}</TableCell>
                                    <TableCell>
                                        <span style={{
                                            display: 'inline-block',
                                            backgroundColor: agence.codeCouleur,
                                            borderRadius: '4px',
                                            padding: '2px 10px',
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            textShadow: '0 1px 2px rgba(0,0,0,0.4)'
                                        }}>
                                            {agence.codeCouleur}
                                        </span>
                                    </TableCell>
                                    <TableCell>{agenceALesCoordonnees(agence) ? 'Oui' : 'Non'}</TableCell>
                                    <TableCell>
                                        <Grid container justify={"flex-end"} spacing={2}>
                                            <Grid item>
                                                <Button color="secondary" size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEditClick(agence.id);
                                                        }}
                                                        startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                                    Editer
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button color="error" size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            openDeleteConfirmModal(agence);
                                                        }}
                                                        startIcon={<CloseOutlinedIcon/>}>
                                                    Supprimer
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <ModalDelete label={label} onClose={handleClose} open={open} objectToDelete={objectToDelete}
                         selectedValue={currentAgence} onDelete={handleDelete}/>
        </React.Fragment>
    );
}

export default AgencesTable;
